import React from 'react';
import { BsArchive, BsChevronDown } from 'react-icons/bs';
import { useDispatch } from 'react-redux';
import { Flex, Icon, Text, Tooltip } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { getAttachmentDownloadUrl } from '../../../../../../../../../../../api/portal-api';
import IconButtonMenu from '../../../../../../../../../../../components/IconButtonMenu';
import { ConfirmActionWarningModal } from '../../../../../../../../../../../components/library';
import StackedButtonGroup from '../../../../../../../../../../../components/Modal/ModalButtonGroups/StackedButtonGroup';
import { analyticsIds } from '../../../../../../../../../../../constants/analyticsIds';
import { inAppText } from '../../../../../../../../../../../constants/inAppText';
import { hideModal, showModal, updateModalOptions } from '../../../../../../../../../../../redux/modules/modal';
import { useUpdateAttachmentStatus } from '../../../../../../../../../../../services/attachment-service';
import { showDontAskAgainModal } from '../../../../../../../../../../../utils/askAgainModalUtil';

const FileNameCell = ({ recordId, attachment }) => {
  const dispatch = useDispatch();
  const { mutate: archiveAttachment } = useUpdateAttachmentStatus({ recordId, status: 'archived' });
  const { mutate: deleteAttachment } = useUpdateAttachmentStatus({ recordId, status: 'deleted' });

  const handleDocClick = async attachmentId => {
    const response = await getAttachmentDownloadUrl(attachmentId);
    window.open(response.url, '_blank');
  };

  const menuOptions = [
    {
      label: 'Archive Attachment',
      icon: BsArchive,
      dataAnalyticsId: analyticsIds.insuredProfilePage.attachmentsComponent.archiveAttachment,
      handler: () => {
        showDontAskAgainModal({
          dispatch,
          cookieId: 'archive-record-attachment-cookie',
          title: 'Archive Attachment?',
          description: 'You can reactivate the attachment at any time.',
          onClick: async () => {
            dispatch(updateModalOptions({ buttons: { primaryButtonOptions: { isLoading: true } } }));
            await archiveAttachment(attachment.id);

            dispatch(hideModal());
            dispatch(updateModalOptions({ buttons: { primaryButtonOptions: { isLoading: false } } }));
          }
        });
      }
    },
    {
      label: 'Delete Attachment',
      icon: BsArchive,
      dataAnalyticsId: analyticsIds.insuredProfilePage.attachmentsComponent.deleteAttachment,
      handler: () => {
        dispatch(showModal(
          () => <ConfirmActionWarningModal description={inAppText.insuredProfile.attachmentsTable.deleteAttachment} />,
          {
            title: 'Delete Attachment?',
            size: 'md',
            buttons: {
              component: StackedButtonGroup,
              primaryButtonOptions: {
                isDisabled: true,
                label: 'Delete',
                onClick: async () => {
                  await deleteAttachment(attachment.id);

                  dispatch(hideModal());
                }
              }
            }
          }
        ));
      }
    }
  ];
  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      key={attachment.id}
      width="300px"
    >
      <Tooltip
        aria-label={`Attachment Name: ${attachment.name}`}
        label={attachment.name}
      >
        <Text
          _hover={{ color: 'primaryScale.600', cursor: 'pointer' }}
          data-analytics-id={analyticsIds.insuredProfilePage.attachmentsComponent.downloadAttachment}
          noOfLines={1}
          pt={0}
          textAlign="left"
          textStyle="button"
          onClick={() => handleDocClick(attachment.id)}
        >
          {attachment.name}
        </Text>
      </Tooltip>
      <IconButtonMenu
        dusk={`documents-option-dropdown_doc-id-${attachment.id}`}
        iconElement={<Icon as={BsChevronDown} size="md" />}
        menuOptions={menuOptions}
      />
    </Flex>
  );
};

FileNameCell.propTypes = {
  recordId: PropTypes.number.isRequired,
  attachment: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string
  }).isRequired
};

export default FileNameCell;
